import useIsMounted from 'ismounted'
import { useCallback, useState } from 'react'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { reportError } from 'utils/error'
import { createDocGenerationRequest, GenerationRequestProps } from '../api/createDocGenerationRequest'
import { AlmanacFile } from 'types'

interface Props {
  onSuccess?: (data: { almanac_file: AlmanacFile }) => any
}

export const useDocGeneration = (hookProps?: Props) => {
  const isMounted = useIsMounted()
  const [isCreating, setIsCreating] = useState(false)
  /* eslint-disable react-hooks/exhaustive-deps */
  const handleGenerate = useCallback(
    async (props: GenerationRequestProps) => {
      if (isCreating) return

      try {
        setIsCreating(true)
        const response = await createDocGenerationRequest(props)

        if (response.type !== SUCCESS_RESPONSE_TYPE) {
          reportError(`Failed to generate doc`, {
            metaData: {
              props,
              response: response.data,
            },
          })
          showErrorMessageToast('There was a problem generating the doc. Our team has been notified.')
          isMounted.current && setIsCreating(false)
          return
        }

        hookProps?.onSuccess?.(response.data)

        return response.data
      } finally {
        isMounted.current && setIsCreating(false)
      }
    },
    [hookProps?.onSuccess, isCreating, isMounted],
  )
  /* eslint-enable react-hooks/exhaustive-deps */

  return { isCreating, handleGenerate }
}
